import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserInfoModel} from '../../services/models/user-info.model';
import {UserService} from '../../services/user.service';
import {Subscription} from 'rxjs';
import {EventsService} from '../../services/events.service';
import {ProgressModel} from '../../services/models/progress.model';
import {ProgressService} from '../../services/progress.service';
import {environment} from '../../../environments/environment';
import {AnalyticsService} from '../../services/analytics.service';
import {NavService} from '../../services/nav.service';
import {Platform} from '@ionic/angular';

@Component({
    selector: 'app-home-page',
    templateUrl: 'home.page.html',
    styleUrls: ['home.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class HomePage implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    environment = null;
    menuVisible = true;

    userInfo: UserInfoModel = null;
    userInfoPromise: Promise<UserInfoModel> = null;
    userInfoValid = false;
    userType = null;

    progress: ProgressModel = null;
    progressPromise: Promise<ProgressModel> = null;
    progressValid = false;
    platform = 'website';

    constructor(
        private event: EventsService,
        private nav: NavService,
        public authService: AuthService,
        public userService: UserService,
        private analytics: AnalyticsService,
        private progressService: ProgressService,
        private platformService: Platform,
        private router: Router,
    ) {
        this.environment = environment;
        this.platform = this.authService.appMobile ? 'mobile' : 'website';

        this.subscriptions.push(
            this.event.subscribe('login', () => {
                this.userInfoValid = false;
                this.progressValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => this.userInfoValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('account.saveMyProfileForm', () => this.userInfoValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('tasks:updateTaskStatus', () => this.progressValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('coach:updateSessionStatus', () => this.progressValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('progress:getMyNotifications', (progress) => {
                this.progress = progress;
                this.progressValid = true;
            })
        );
    }

    ngOnInit(): void {
        // this.platform = environment.platform;
    }


    ionViewWillEnter() {
        this.menuVisible = false;
        this.userType = this.authService.getUserType();

        if (this.userInfo === null || !this.userInfoValid) {
            this.userInfoPromise = this.userService.getUserInfo();
        }

        if (this.progress === null || !this.progressValid) {
            this.progressPromise = this.progressService.getMyNotifications();
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('My Home');

        // setTimeout(() => {
            this.menuVisible = true;
        // }, 300);

        if (!!this.userInfoPromise && (this.userInfo === null || !this.userInfoValid)) {
            this.userInfoPromise.then(data => {
                this.userInfo = data;
                this.userInfoValid = true;
            });
        }

        if (!!this.progressPromise && (this.progress === null || !this.progressValid)) {
            this.progressPromise.then(data => {
                this.progress = data;
                this.progressValid = true;
            });
        }
    }

    goToLink(link) {
        this.nav.toLink(link);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
